import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { adminRouteRef, rootRouteRef } from './routes';

export const installationsPlugin = createPlugin({
  id: 'installations',
  routes: {
    root: rootRouteRef,
    admin: adminRouteRef,
  },
});

export const InstallationsPage = installationsPlugin.provide(
  createRoutableExtension({
    name: 'InstallationsPage',
    component: () => import('./components/index').then(m => m.IndexPage),
    mountPoint: rootRouteRef,
  }),
);

export const AdminPage = installationsPlugin.provide(
  createRoutableExtension({
    name: 'AdminPage',
    component: () => import('./components/admin').then(m => m.AdminPage),
    mountPoint: adminRouteRef,
  }),
);
